module.exports = InternalShared('InternalShared/PageBuilder/DragAndDrop/KeyDownManager');